<template>
  <div id="page">
    <b-container class="lefttext">
      <b-form>
        <b-form-group id="input-group-1" label="姓名:" label-for="input-1">
          <b-form-input
            id="input-1"
            v-model="form.name"
            required
            placeholder="请输入姓名"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-2" label="身份证号:" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="form.idNo"
            required
            placeholder=" 请输入身份证号"
          ></b-form-input>
        </b-form-group>

        <b-form-group id="input-group-3" label="手机号:" label-for="input-3">
          <b-form-input
            id="input-3"
            v-model="form.mobile"
            required
            placeholder=" 请输入手机号"
          ></b-form-input>
        </b-form-group>

        <div class="form-group">
          <label>验证码:</label>
          <div class="form-inline">
            <b-form-input
              v-model="form.smsCode"
              placeholder="请输入验证码"
              style="width: auto"
            ></b-form-input>
            <b-button variant="success" class="smsBtn">获取</b-button>
          </div>
        </div>
        <div align="center" class="actionArea">
          <b-button
            block
            variant="success"
            style="width: 80%"
            @click="toAddress()"
            >下一步</b-button
          >
        </div>
      </b-form>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "Identity",
  data() {
    return {
      form: {
        name: "",
        idNo: "",
        mobile: "",
        smsCode: "",
      },
    };
  },
  methods: {
    toAddress: function () {
      var obj = {
        name: this.form.name,
        idNo: this.form.idNo,
        mobile: this.form.mobile,
        smsCode: this.form.smsCode,
      };

      var identiy = JSON.stringify(obj);
      console.log("identiy:" + identiy);

      this.$router.push({
        name: "MailAddress",
        params: {
          identiy: identiy,
        },
      });
    },
  },
};
</script>

<style scoped>
.lefttext {
  text-align: left;
}
.actionArea {
  margin-top: 32px;
  margin-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/Identity.vue